import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  root: {
    fontSize: "0.875rem",
    borderRadius: 7,
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#E3E3E3",
      },
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8125rem",
    },
  },
  inputRoot: {
    fontSize: "inherit",
    "& .Mui-disabled": {
      color: "#000000de",
    },
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
  },
  headerText: {
    textAlign: "left",
    fontSize: "0.875rem",
    fontWeight: 600,
    letterSpacing: 0,
    color: "#00003D",
    textTransform: "uppercase",
    opacity: 1,
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8125rem",
    },
  },
  formHelperText: {
    left: "1%",
    top: "90%",
    position: "absolute",
    marginLeft: 0,
  },
}))

export default styles
